export default __webpack_public_path__ + "static/media/tom-icon.b8b54f0d.png";